<td class="order-overview-table_image">
  <a
    [description]="shoppingCartLine.description"
    [imageFormat]="137"
    [image]="image"
    [routerLink]="['/products/detail', {origin: 'cart', type: shoppingCartLine.type, priceListNo: shoppingCartLine.priceListNo, priceListLineNo: shoppingCartLine.priceListLineNo}]"
    render-product-image
  ></a>
</td>
<th class="order-overview-table_product" colspan="3" scope="row">
  <a
    [routerLink]="['/products/detail', {origin: 'cart', type: shoppingCartLine.type, priceListNo: shoppingCartLine.priceListNo, priceListLineNo: shoppingCartLine.priceListLineNo}]"
    >
    {{shoppingCartLine.description}}
  </a>
  @if (shoppingCartLine.vendorName) {
    <span
      class="order-overview-table_product--vendor"
      >
      {{shoppingCartLine.vendorName}}
    </span>
  }
  @if (shoppingCartLine.features) {
    <span
      class="order-overview-table_product--features"
      >
      {{shoppingCartLine.features}}
    </span>
  }
</th>
<td class="order-overview-table_amount">
  <strong
    class="order-overview-table_label"
    i18n="pending order detail: amount header@@order.amount"
    >Amount</strong
    >
    @if (isEditable) {
      <form [formGroup]="valueForm">
        <input
          [formControl]="valueForm.controls['quantity']"
          autocomplete="off"
          class="quantity-input_input input--small"
          min="{{minValue}}"
          type="number"
          />
      </form>
    }

    @if (!isEditable) {
      {{getQuantity()}}
    }

    @if (shoppingCartLine.qtyByBox >= 1) {
      x {{shoppingCartLine.qtyByBox}}
    }
  </td>
  <td class="order-overview-table_potsize">
    <strong
      class="order-overview-table_label"
      i18n="pending order detail: pot size@@order.potsize"
      >Pot size</strong
      >
      <div class="order-overview-table_icon-text">
        <svg class="icon-potsize" height="11" viewBox="0 0 16 11" width="16">
          <use xlink:href="/images/icons/svg-sprite.svg#potsize"></use>
        </svg>
        <span>{{shoppingCartLine.gradeCode1 || "-"}}</span>
      </div>
    </td>
    <td class="order-overview-table_height">
      <strong
        class="order-overview-table_label"
        i18n="pending order detail: height@@order.height"
        >Height</strong
        >
        <div class="order-overview-table_icon-text">
          <svg class="icon-potheight" height="11" viewBox="0 0 6 11" width="6">
            <use xlink:href="/images/icons/svg-sprite.svg#potheight"></use>
          </svg>
          <span>{{shoppingCartLine.gradeCode2 || "-"}}</span>
        </div>
      </td>
      <td class="order-overview-table_volume">
        <strong
          class="order-overview-table_label"
          i18n="pending order detail: volume header@@order.volume"
          >Volume</strong
          >
          <span i18n="Calculated volume (CC)@@calculated.volume"
            >{{shoppingCartLine.volume | numberFormat:false}} CC</span
            >
          </td>
          @if (!showBarcode) {
            <td class="order-overview-table_price">
              <strong
                class="order-overview-table_label"
                i18n="pending order detail: price header@@order.price"
                >Price</strong
                >
                {{applicationService.getUserCurrency()}} {{getPriceForLine() |
                numberFormat:true}}
              </td>
            }
            @if (showBarcode) {
              <td class="order-overview-table_price">
                <strong
                  class="order-overview-table_label"
                  i18n="pending order detail: price header@@order.price"
                  >Price</strong
                  >
                  {{applicationService.getUserCurrency()}} {{getPriceForLine() |
                  numberFormat:true}}
                </td>
              }
              @if (allowComment) {
                <td class="order-overview-table_comment">
                  <button
                    (click)="addCommentView()"
                    class="button theme-btn-primary"
                    type="button"
                    >
                    <span class="order-detail-actions_icon">
                      @if (!hasComment) {
                        <svg class="icon-comment" height="19" width="20">
                          <use xlink:href="/images/icons/svg-sprite.svg#comment"></use>
                        </svg>
                      }
                      @if (hasComment) {
                        <svg
                          class="icon-comment-highlight"
                          height="19"
                          width="20"
                          >
                          <use xlink:href="/images/icons/svg-sprite.svg#comment-highlight"></use>
                        </svg>
                      }
                    </span>
                    <span class="order-overview-table_label">Comment</span>
                  </button>
                </td>
              }
              <td class="order-overview-table_delete">
                @if (isEditable) {
                  <cart-line-remove
                    (removeEvent)="removeProduct()"
                    [buttonDisabled]="removeButtonDisabled"
                    [expiryDate]="expiryDate"
                    [isEditable]="isEditable"
                    [isFastCheckoutMode]="!shoppingCartLine.shoppingCartMode"
                    [maxUserCartWaitTimeInSeconds]="getUserCartWaitTimeInSeconds()"
                    days="days"
                    hours="hours"
                    i18n-days="@@shoppingcart.time.remaining.days"
                    i18n-hours="@@shoppingcart.time.remaining.hours"
                    i18n-label="@@shoppingcart.time.remaining"
                    i18n-minutes="@@shoppingcart.time.remaining.minutes"
                    i18n-seconds="@@shoppingcart.time.remaining.seconds"
                    label="Time remaining:"
                    minutes="minutes"
                    seconds="seconds"
                    >
                  </cart-line-remove>
                }
              </td>

              <ng-template modal-wrapper></ng-template>
